import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "pgm-dashboard" }
const _hoisted_2 = { class: "dashboard-header" }
const _hoisted_3 = { class: "header-left" }
const _hoisted_4 = { class: "dashboard-title" }
const _hoisted_5 = { class: "dashboard-subtitle" }
const _hoisted_6 = { class: "header-right" }
const _hoisted_7 = { class: "wage-process-section" }
const _hoisted_8 = { class: "kpi-grid" }
const _hoisted_9 = { class: "kpi-card kpi-card-modern primary-card" }
const _hoisted_10 = { class: "kpi-card-content" }
const _hoisted_11 = { class: "kpi-top-section" }
const _hoisted_12 = { class: "kpi-label-wrapper" }
const _hoisted_13 = { class: "kpi-subtitle" }
const _hoisted_14 = { class: "kpi-icon-wrapper primary" }
const _hoisted_15 = { class: "kpi-value-section" }
const _hoisted_16 = { class: "kpi-value" }
const _hoisted_17 = {
  key: 0,
  class: "kpi-latest-month"
}
const _hoisted_18 = { class: "latest-badge" }
const _hoisted_19 = { class: "badge-month" }
const _hoisted_20 = { class: "latest-amount" }
const _hoisted_21 = { class: "kpi-card kpi-card-modern success-card" }
const _hoisted_22 = { class: "kpi-card-content" }
const _hoisted_23 = { class: "kpi-top-section" }
const _hoisted_24 = { class: "kpi-label-wrapper" }
const _hoisted_25 = { class: "kpi-subtitle" }
const _hoisted_26 = { class: "kpi-icon-wrapper success" }
const _hoisted_27 = { class: "kpi-value-section" }
const _hoisted_28 = { class: "kpi-value" }
const _hoisted_29 = {
  key: 0,
  class: "kpi-latest-month"
}
const _hoisted_30 = { class: "latest-badge" }
const _hoisted_31 = { class: "badge-month" }
const _hoisted_32 = { class: "latest-amount" }
const _hoisted_33 = { class: "kpi-card kpi-card-modern info-card" }
const _hoisted_34 = { class: "kpi-card-content" }
const _hoisted_35 = { class: "kpi-top-section" }
const _hoisted_36 = { class: "kpi-icon-wrapper info" }
const _hoisted_37 = { class: "kpi-value-section" }
const _hoisted_38 = { class: "kpi-value" }
const _hoisted_39 = {
  key: 0,
  class: "kpi-latest-month"
}
const _hoisted_40 = { class: "latest-badge" }
const _hoisted_41 = { class: "badge-month" }
const _hoisted_42 = { class: "latest-amount" }
const _hoisted_43 = { class: "kpi-card kpi-card-modern warning-card" }
const _hoisted_44 = { class: "kpi-card-content" }
const _hoisted_45 = { class: "kpi-top-section" }
const _hoisted_46 = { class: "kpi-label-wrapper" }
const _hoisted_47 = { class: "kpi-subtitle" }
const _hoisted_48 = { class: "kpi-icon-wrapper warning" }
const _hoisted_49 = { class: "kpi-value-section" }
const _hoisted_50 = { class: "kpi-value" }
const _hoisted_51 = {
  key: 0,
  class: "kpi-latest-month"
}
const _hoisted_52 = { class: "latest-badge" }
const _hoisted_53 = { class: "badge-month" }
const _hoisted_54 = { class: "latest-amount" }
const _hoisted_55 = { class: "charts-section" }
const _hoisted_56 = { class: "header-content" }
const _hoisted_57 = { class: "header-left-content" }
const _hoisted_58 = { class: "charts-title" }
const _hoisted_59 = { class: "news-section" }

import { ref, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import axios from 'axios';
import LodingComponent from '@/components/loading/LodingComponent.vue';
import NewsList from '@/components/dashboard/NewsList.vue';
import GraphChart from '@/components/dashboard/GraphChart.vue';
import WageProcessStatus from '@/components/dashboard/WageProcessStatus.vue';
import MemberUploadModal from '@/components/employee/MemberUploadModal.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'PgmDashBoard',
  setup(__props) {

const store = useStore();
const router = useRouter();

// 로딩 상태
const isLoading = ref(false);
const loadingText = ref('로딩 중...');

// 연도 선택
const currentYear = new Date().getFullYear();
const selectedYear = ref(currentYear);
const availableYears = ref(
  Array.from({ length: 11 }, (_, i) => {
    const year = currentYear - 5 + i;
    return { value: year, text: `${year}년` };
  })
);

// 급여 마감 데이터
const wageMagamData = ref<any[]>([]);

// 요양보호사 정보
const showMemberUploadDialog = ref(false);

// 스낵바 표시
const showSnackbar = (text: string, color: string = 'success') => {
  const timeout = color === 'error' && text.length > 100 ? 8000 : 4000;
  store.commit('showSnackbar', { text, color, timeout });
};

// 연도 변경 핸들러
const onYearChange = async (newYear: number) => {
  selectedYear.value = newYear;
  await fetchYearlyWageMagamData(newYear);
};

// 급여 마감 데이터 조회
const fetchYearlyWageMagamData = async (year: number) => {
  try {
    const user = store.state.user;
    if (!user || !user.m_sisul_code) {
      console.warn('사용자 정보가 없습니다.');
      return;
    }

    isLoading.value = true;
    loadingText.value = '급여 데이터를 불러오는 중...';

    const response = await axios.get(`/api/calc/wage-magam-yearly/${user.m_sisul_code}/${year}`, {
      withCredentials: true
    });

    if (response.data.success) {
      wageMagamData.value = response.data.data;
    } else {
      console.error('급여 마감 데이터 조회 실패:', response.data.message);
      wageMagamData.value = [];
    }
  } catch (error) {
    console.error('급여 마감 데이터 조회 오류:', error);
    wageMagamData.value = [];
  } finally {
    isLoading.value = false;
  }
};

// 요양보호사 정보 모달 열기 (사용되지 않지만 UI에서 접근 가능하도록 유지)
const openMemberUploadDialog = () => {
  showMemberUploadDialog.value = true;
};

// 사원 정보 업로드 완료 핸들러
const handleMemberUploaded = () => {
  // 업로드 완료 후 필요한 처리
};

// 가장 최근 마감된 월 찾기
const getLatestMagamMonth = (): { month: number; yearMonth: string } | null => {
  if (!wageMagamData.value || wageMagamData.value.length === 0) return null;
  
  const totalData = wageMagamData.value.filter(item => item.wm_job_type === '전체합계');
  if (totalData.length === 0) return null;
  
  // wm_ym 기준으로 정렬 (내림차순)
  const sortedData = [...totalData].sort((a, b) => {
    const aYm = parseInt(a.wm_ym || '0');
    const bYm = parseInt(b.wm_ym || '0');
    return bYm - aYm;
  });
  
  if (sortedData.length === 0) return null;
  
  const latest = sortedData[0];
  const yearMonth = latest.wm_ym || '';
  const month = parseInt(yearMonth.substring(4, 6));
  
  return { month, yearMonth };
};

// 최근 한 달 데이터 가져오기
const getLatestMonthData = () => {
  const latest = getLatestMagamMonth();
  if (!latest) return null;
  
  const latestData = wageMagamData.value.find(
    item => item.wm_job_type === '전체합계' && item.wm_ym === latest.yearMonth
  );
  
  if (!latestData) return null;
  
  return {
    month: latest.month,
    wage: parseInt(latestData.wm_wage_sum) || 0,
    profit: parseInt(latestData.wm_center_profit) || 0,
    savings: parseInt(latestData.wm_center_savings) || 0,
    count: parseInt(latestData.wm_count) || 0
  };
};

// KPI 계산 함수들
const getTotalWage = (): number => {
  if (!wageMagamData.value || wageMagamData.value.length === 0) return 0;
  
  return wageMagamData.value
    .filter(item => item.wm_job_type === '전체합계')
    .reduce((sum, item) => sum + (parseInt(item.wm_wage_sum) || 0), 0);
};

const getTotalProfit = (): number => {
  if (!wageMagamData.value || wageMagamData.value.length === 0) return 0;
  
  return wageMagamData.value
    .filter(item => item.wm_job_type === '전체합계')
    .reduce((sum, item) => sum + (parseInt(item.wm_center_profit) || 0), 0);
};

const getAverageEmployeeCount = (): number => {
  if (!wageMagamData.value || wageMagamData.value.length === 0) return 0;
  
  const totalData = wageMagamData.value.filter(item => item.wm_job_type === '전체합계');
  if (totalData.length === 0) return 0;
  
  const totalCount = totalData.reduce((sum, item) => sum + (parseInt(item.wm_count) || 0), 0);
  return Math.round(totalCount / totalData.length);
};

const getTotalSavings = (): number => {
  if (!wageMagamData.value || wageMagamData.value.length === 0) return 0;
  
  return wageMagamData.value
    .filter(item => item.wm_job_type === '전체합계')
    .reduce((sum, item) => {
      const centerSavings = parseInt(item.wm_center_savings) || 0;
      return sum + centerSavings;
    }, 0);
};

const formatCurrency = (value: number): string => {
  if (value >= 10000) {
    const tenThousands = Math.floor(value / 10000);
    return `${tenThousands.toLocaleString()}만`;
  }
  return value.toLocaleString();
};

// 천원 단위까지 표시하는 포맷 함수 (총 절감액용)
const formatCurrencyWithThousands = (value: number): string => {
  if (value >= 10000) {
    const tenThousands = Math.floor(value / 10000);
    const thousands = Math.floor((value % 10000) / 1000);
    if (thousands > 0) {
      return `${tenThousands.toLocaleString()}만${thousands}천`;
    }
    return `${tenThousands.toLocaleString()}만`;
  }
  return value.toLocaleString();
};

// 컴포넌트 마운트 시
onMounted(async () => {
  await store.dispatch('validateAuth');
  await fetchYearlyWageMagamData(selectedYear.value);
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(LodingComponent, {
      "is-visible": isLoading.value,
      text: loadingText.value
    }, null, 8, ["is-visible", "text"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, [
          (_unref(store).state.user?.m_sisul_name)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(_unref(store).state.user.m_sisul_name), 1)
              ], 64))
            : (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                to: "/pgm/userinfo",
                class: "facility-name-link"
              }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode(" 기관명을 입력해주세요 ", -1)
                ]))]),
                _: 1
              }))
        ]),
        _createElementVNode("p", _hoisted_5, _toDisplayString(selectedYear.value) + "년 기관 운영 현황을 한눈에 확인하세요.", 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_v_select, {
          modelValue: selectedYear.value,
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = ($event: any) => ((selectedYear).value = $event)),
            onYearChange
          ],
          items: availableYears.value,
          "item-title": "text",
          "item-value": "value",
          variant: "outlined",
          density: "compact",
          "hide-details": "",
          class: "year-select-header",
          "prepend-inner-icon": "mdi-calendar"
        }, null, 8, ["modelValue", "items"])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(WageProcessStatus, { "selected-year": selectedYear.value }, null, 8, ["selected-year"])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _cache[3] || (_cache[3] = _createElementVNode("span", { class: "kpi-label" }, "총 인건비", -1)),
              _createElementVNode("span", _hoisted_13, _toDisplayString(selectedYear.value) + "년 누적", 1)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_v_icon, {
                color: "white",
                size: "32"
              }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createTextVNode("mdi-cash-multiple", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("h2", _hoisted_16, _toDisplayString(formatCurrency(getTotalWage())), 1),
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "kpi-trend-wrapper" }, null, -1)),
            (getLatestMonthData())
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_v_icon, {
                      size: "14",
                      class: "badge-icon"
                    }, {
                      default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                        _createTextVNode("mdi-calendar-month", -1)
                      ]))]),
                      _: 1
                    }),
                    _createElementVNode("span", _hoisted_19, _toDisplayString(getLatestMonthData()?.month) + "월", 1)
                  ]),
                  _createElementVNode("span", _hoisted_20, _toDisplayString(formatCurrency(getLatestMonthData()?.wage || 0)), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "kpi-card-accent primary" }, null, -1))
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _cache[8] || (_cache[8] = _createElementVNode("span", { class: "kpi-label" }, "센터 수익", -1)),
              _createElementVNode("span", _hoisted_25, _toDisplayString(selectedYear.value) + "년 누적", 1)
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createVNode(_component_v_icon, {
                color: "white",
                size: "32"
              }, {
                default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                  _createTextVNode("mdi-chart-line", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("h2", _hoisted_28, _toDisplayString(formatCurrency(getTotalProfit())), 1),
            _cache[11] || (_cache[11] = _createElementVNode("div", { class: "kpi-trend-wrapper" }, null, -1)),
            (getLatestMonthData())
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _createVNode(_component_v_icon, {
                      size: "14",
                      class: "badge-icon"
                    }, {
                      default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                        _createTextVNode("mdi-calendar-month", -1)
                      ]))]),
                      _: 1
                    }),
                    _createElementVNode("span", _hoisted_31, _toDisplayString(getLatestMonthData()?.month) + "월", 1)
                  ]),
                  _createElementVNode("span", _hoisted_32, _toDisplayString(formatCurrency(getLatestMonthData()?.profit || 0)), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _cache[12] || (_cache[12] = _createElementVNode("div", { class: "kpi-card-accent success" }, null, -1))
      ]),
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _cache[14] || (_cache[14] = _createElementVNode("div", { class: "kpi-label-wrapper" }, [
              _createElementVNode("span", { class: "kpi-label" }, "평균 직원 수"),
              _createElementVNode("span", { class: "kpi-subtitle" }, "월평균 인원")
            ], -1)),
            _createElementVNode("div", _hoisted_36, [
              _createVNode(_component_v_icon, {
                color: "white",
                size: "32"
              }, {
                default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                  _createTextVNode("mdi-account-group", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("h2", _hoisted_38, [
              _createTextVNode(_toDisplayString(getAverageEmployeeCount()), 1),
              _cache[15] || (_cache[15] = _createElementVNode("span", { class: "value-unit" }, "명", -1))
            ]),
            _cache[17] || (_cache[17] = _createElementVNode("div", { class: "kpi-trend-wrapper" }, null, -1)),
            (getLatestMonthData())
              ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                  _createElementVNode("div", _hoisted_40, [
                    _createVNode(_component_v_icon, {
                      size: "14",
                      class: "badge-icon"
                    }, {
                      default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                        _createTextVNode("mdi-calendar-month", -1)
                      ]))]),
                      _: 1
                    }),
                    _createElementVNode("span", _hoisted_41, _toDisplayString(getLatestMonthData()?.month) + "월", 1)
                  ]),
                  _createElementVNode("span", _hoisted_42, _toDisplayString(getLatestMonthData()?.count || 0) + "명", 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _cache[18] || (_cache[18] = _createElementVNode("div", { class: "kpi-card-accent info" }, null, -1))
      ]),
      _createElementVNode("div", _hoisted_43, [
        _createElementVNode("div", _hoisted_44, [
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, [
              _cache[19] || (_cache[19] = _createElementVNode("span", { class: "kpi-label" }, "총 절감액", -1)),
              _createElementVNode("span", _hoisted_47, _toDisplayString(selectedYear.value) + "년 누적", 1)
            ]),
            _createElementVNode("div", _hoisted_48, [
              _createVNode(_component_v_icon, {
                color: "white",
                size: "32"
              }, {
                default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                  _createTextVNode("mdi-piggy-bank", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("h2", _hoisted_50, _toDisplayString(formatCurrencyWithThousands(getTotalSavings())), 1),
            _cache[22] || (_cache[22] = _createElementVNode("div", { class: "kpi-trend-wrapper" }, null, -1)),
            (getLatestMonthData())
              ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                  _createElementVNode("div", _hoisted_52, [
                    _createVNode(_component_v_icon, {
                      size: "14",
                      class: "badge-icon"
                    }, {
                      default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                        _createTextVNode("mdi-calendar-month", -1)
                      ]))]),
                      _: 1
                    }),
                    _createElementVNode("span", _hoisted_53, _toDisplayString(getLatestMonthData()?.month) + "월", 1)
                  ]),
                  _createElementVNode("span", _hoisted_54, _toDisplayString(formatCurrencyWithThousands(getLatestMonthData()?.savings || 0)), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _cache[23] || (_cache[23] = _createElementVNode("div", { class: "kpi-card-accent warning" }, null, -1))
      ])
    ]),
    _createElementVNode("div", _hoisted_55, [
      _createVNode(_component_v_card, {
        class: "charts-container-card",
        elevation: "0"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "charts-header" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_56, [
                _createElementVNode("div", _hoisted_57, [
                  _createVNode(_component_v_icon, {
                    color: "#1e3a8a",
                    class: "header-icon"
                  }, {
                    default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                      _createTextVNode("mdi-chart-box-multiple", -1)
                    ]))]),
                    _: 1
                  }),
                  _createElementVNode("div", null, [
                    _createElementVNode("h2", _hoisted_58, _toDisplayString(selectedYear.value) + "년 통계 분석", 1),
                    _cache[25] || (_cache[25] = _createElementVNode("p", { class: "charts-subtitle" }, "월별 데이터 추이 및 비교 분석", -1))
                  ])
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, { class: "charts-content" }, {
            default: _withCtx(() => [
              _createVNode(GraphChart, { "chart-data": wageMagamData.value }, null, 8, ["chart-data"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_59, [
      _createVNode(NewsList)
    ]),
    _createVNode(MemberUploadModal, {
      modelValue: showMemberUploadDialog.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showMemberUploadDialog).value = $event)),
      onUploaded: handleMemberUploaded
    }, null, 8, ["modelValue"])
  ]))
}
}

})